export const COMPONENT_NAME = 'BusinessFacility';